import * as React from 'react'
import fetchFromAlgolia from 'utils/productListFetcher/bySwUuid'
import { Product as RawProduct } from 'utils/productListFetcher/types'

export type Product = {
  loading: boolean
  imageUrl: { url: string; classes: string[] }
  title: string
  subtitle: string
  sw6Uuid: string
}

export default function useOrderProducts(uuids: string[]) {
  const [products, setProducts] = React.useState<Product[]>(() => {
    return uuids.map((uuid) => ({
      loading: true,
      imageUrl: { url: '', classes: [] },
      title: '',
      subtitle: '',
      sw6Uuid: uuid
    }))
  })

  React.useEffect(() => {
    fetchFromAlgolia({
      sw6Uuids: uuids,
      maxHits: 1000,
      keepSorting: true,
      noDistinct: true
    })(0).then((products) => {
      const dict: Record<string, RawProduct> = {}
      for (const p of products.data) dict[p.sw6Uuid] = p
      const result: Product[] = []
      for (const uuid of uuids) {
        const p = dict[uuid]
        if (!p) continue
        result.push({
          loading: false,
          imageUrl: p.images.imageWeb[0],
          subtitle: p.subtitle,
          title: p.title,
          sw6Uuid: p.sw6Uuid
        })
      }
      setProducts(result)
    })
  }, [uuids])

  return products
}
